/* ==========================================================================
   Reckless Branding - card expansion + grid motion
   Added 2026-08-24.

   Pairs with reckless-transitions.css. Every effect is additive and guarded:
   if anything here throws, the store behaves exactly as it did before.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HERO = 'product-hero';

  /* ----------------------------------------------------------------------
     1. CARD EXPANSION
     On the collection page, name the clicked card's image. On the product
     page, name the hero image. Same name = the browser tweens between them.
     Names must be unique per document, so only ever one element is named.
     ---------------------------------------------------------------------- */

  function clearNames() {
    document.querySelectorAll('[data-rb-named]').forEach(function (el) {
      el.style.viewTransitionName = '';
      el.removeAttribute('data-rb-named');
    });
  }

  function nameIt(el) {
    if (!el) return;
    clearNames();
    el.style.viewTransitionName = HERO;
    el.setAttribute('data-rb-named', '');
  }

  // Collection / featured grids: tag the image inside the card being opened.
  document.addEventListener(
    'click',
    function (e) {
      try {
        var link = e.target.closest('a[href*="/products/"]');
        if (!link) return;
        var wrapper = link.closest('.card-wrapper, .grid__item');
        if (!wrapper) return;

        wrapper.classList.add('rb-pressed');
        setTimeout(function () {
          wrapper.classList.remove('rb-pressed');
        }, 220);

        if (REDUCED) return;
        nameIt(wrapper.querySelector('.card__media img, .media img, img'));
      } catch (err) {
        /* never block navigation */
      }
    },
    true
  );

  // Product page: tag the main gallery image so it is the arrival point.
  function tagProductHero() {
    if (REDUCED) return;
    if (!/\/products\//.test(window.location.pathname)) return;
    var img =
      document.querySelector('.product__media-item:not([hidden]) img') ||
      document.querySelector('.product__media img') ||
      document.querySelector('.product-media-container img') ||
      document.querySelector('media-gallery img');
    nameIt(img);
  }

  /* Back/forward: a restored page must not keep a stale name, or the next
     transition finds two elements claiming it and silently does nothing. */
  window.addEventListener('pageswap', clearNames);
  window.addEventListener('pagehide', clearNames);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) clearNames();
  });

  /* ----------------------------------------------------------------------
     2. GRID ENTRY
     Reveal cards as they scroll in, staggered across each row.
     ---------------------------------------------------------------------- */

  function revealGrids() {
    if (REDUCED) return;
    if (!('IntersectionObserver' in window)) return;

    var cards = document.querySelectorAll(
      '.product-grid .grid__item, .collection .grid__item'
    );
    if (!cards.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = Number(el.dataset.rbIndex || 0) % 4;
          el.style.setProperty('--rb-delay', delay * 55 + 'ms');
          el.classList.add('rb-in');
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0.05 }
    );

    cards.forEach(function (el, i) {
      // only hide it once we know the observer is live
      el.dataset.rbIndex = i;
      el.classList.add('rb-reveal');
      io.observe(el);
    });

    /* Safety net: if anything stops the observer firing, show everything
       after 1.2s rather than leaving a customer staring at a blank grid. */
    setTimeout(function () {
      cards.forEach(function (el) {
        el.classList.add('rb-in');
      });
    }, 1200);
  }

  /* ----------------------------------------------------------------------
     3. ADD TO CART
     Pulse the cart icon when the count actually changes.
     ---------------------------------------------------------------------- */

  function watchCart() {
    if (REDUCED) return;
    var bubble =
      document.querySelector('.cart-count-bubble') ||
      document.querySelector('#cart-icon-bubble');
    if (!bubble) return;

    var mo = new MutationObserver(function () {
      bubble.classList.remove('rb-cart-pulse');
      void bubble.offsetWidth; // restart the animation
      bubble.classList.add('rb-cart-pulse');
    });
    mo.observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------------- */

  function init() {
    try {
      tagProductHero();
      revealGrids();
      watchCart();
    } catch (err) {
      /* leave the store working no matter what */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
